// ═══ 세금계산서 발행/조회 페이지 ═══
import ReactDOM from 'react-dom';
import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';
import CompanyListPanel from './CompanyListPanel';
import TaxInvoiceDrafts from './TaxInvoiceDrafts';
import TaxInvoicePopbillLists from './TaxInvoicePopbillLists';
import TaxInvoiceCarPickModal, { buildCarItems, saveCarSaleDrafts } from './TaxInvoiceCarPickModal';
import TaxInvoiceSettlementPickModal from './TaxInvoiceSettlementPickModal';
// 말소대행 계정 한정 — 헤더 탭을 대행요청·정산과 같은 밑줄 탭으로 (Jin 8/26). 타 계정은 종전 pill.
import CaHeaderTabs from './CaHeaderTabs';
import { useIsMobile } from '../utils/useMobile';

function TaxInvoicePage({ showToast, user }) {
  var isAdmin = user && (user.role === '\uAD00\uB9AC\uC790' || user.role === 'admin');
  var isDocAgency = user && user.role === 'doc_agency';
  // 말소대행사 계정 — 공급자 = 대행사(정산 불러오기 시 supplier 스냅샷). 국내 매각 차량은 해당 없음.
  var isCancelAgency = user && user.role === 'cancel_agency';
  var isMobile = useIsMobile();   // 밑줄 탭 치수 분기 (대행사 갈래에서만 소비)
  // ⚠ 모바일 레이아웃 분기는 **대행사 계정에서만** 켠다 (caMob). 수출업체·관세사·관리자 렌더는
  //   좁은 화면에서도 종전 그대로 — 회귀 테스트가 role:'user' 의 종전 pill/DOM 을 못으로 박고 있다.
  var caMob = isCancelAgency && isMobile;
  var showCompanyFilter = isAdmin || isDocAgency;
  var [filterCompanyId, setFilterCompanyId] = useState(
    (isAdmin || isDocAgency) && user ? (user.activeCompanyId || user.companyId || '') : ''
  );
  var [tab, setTab] = useState('issue');
  var [company, setCompany] = useState({});
  var [list, setList] = useState([]);
  var [listLoading, setListLoading] = useState(false);
  var [issuing, setIssuing] = useState(false);
  var [savingDraft, setSavingDraft] = useState(false);
  var [editingDraftId, setEditingDraftId] = useState(null);
  // 발행 건 소스 추적 (판매 차량 불러오기 → car_sale + 차량 id)
  var [sourceType, setSourceType] = useState('manual');
  var [sourceCarIds, setSourceCarIds] = useState([]);
  var [carPickOpen, setCarPickOpen] = useState(false);
  var [settlementPickOpen, setSettlementPickOpen] = useState(false);

  var [receivedList, setReceivedList] = useState([]);
  var [receivedLoading, setReceivedLoading] = useState(false);
  var [corpCheckResult, setCorpCheckResult] = useState(null);
  var [corpChecking, setCorpChecking] = useState(false);

  // 공급받는자
  var [rcvBizNo, setRcvBizNo] = useState('');
  var [rcvName, setRcvName] = useState('');
  var [rcvCeo, setRcvCeo] = useState('');
  var [rcvAddr, setRcvAddr] = useState('');
  var [rcvBizType, setRcvBizType] = useState('');
  var [rcvBizItem, setRcvBizItem] = useState('');
  var [rcvEmail, setRcvEmail] = useState('');

  // 품목
  var [items, setItems] = useState([{ date: new Date().toISOString().slice(0, 10).replace(/-/g, ''), itemName: '', spec: '', qty: '1', unitCost: '', supplyCost: '', tax: '', note: '' }]);

  // 발행 옵션
  var [purposeType, setPurposeType] = useState('\uC601\uC218');
  var [taxType, setTaxType] = useState('\uACFC\uC138');

  // 공급자 정보 (editable)
  var [supBizNo, setSupBizNo] = useState('');
  var [supName, setSupName] = useState('');
  var [supCeo, setSupCeo] = useState('');
  var [supAddr, setSupAddr] = useState('');
  var [supBizType, setSupBizType] = useState('');
  var [supBizItem, setSupBizItem] = useState('');
  var [supTel, setSupTel] = useState('');
  var [supEmail, setSupEmail] = useState('');

  // 헤더 좌측 슬롯 (#dash-header-slot-left) — 탭 버튼을 '세금계산서' 타이틀 줄로 올려
  // 본문 세로 공간을 돌려준다 (Jin 지시). CancelAgencySettlement 와 같은 포털 패턴.
  var [hdrSlotL, setHdrSlotL] = useState(null);
  useEffect(function () { setHdrSlotL(document.getElementById('dash-header-slot-left') || null); }, [tab]);

  // 업체 정보 로드 — 대행사(companyId=0)는 업체가 없으므로 자기 대행사 정보를 채운다.
  //   서버 export 도 스냅샷 없으면 cancel_agencies 로 폴백하므로 화면 표시와 실제 발급값이 같다.
  useEffect(function () {
    if (isCancelAgency) {
      authFetch(API + '/rider/my-agency').then(function (r) { return r.json(); }).then(function (d) {
        var a = (d && d.agency) || {};
        setSupBizNo(a.bizNo || '');
        setSupName(a.name || '');
        setSupCeo(a.ceo || '');
        setSupAddr(a.addr || '');
        setSupTel(a.tel || '');
      }).catch(function () { });
      return;
    }
    var cid = filterCompanyId || (user && (user.activeCompanyId || user.companyId)) || '';
    if (!cid) return;
    authFetch(API + '/settings/company?companyId=' + cid).then(function (r) { return r.json(); }).then(function (d) {
      setCompany(d || {});
      setSupBizNo((d && d.bizNo) || '');
      setSupName((d && (d.nameKr || d.companyName)) || '');
      setSupCeo((d && d.ceo) || '');
      setSupAddr((d && (d.addrKr || d.addr)) || '');
      setSupBizType((d && d.bizType) || '');
      setSupBizItem((d && d.bizItem) || '');
      setSupTel((d && d.tel) || '');
      setSupEmail((d && d.email) || '');
    }).catch(function () { });
  }, [filterCompanyId, user, isCancelAgency]);

  // 목록 로드
  var loadList = function () {
    setListLoading(true);
    var today = new Date();
    var startDate = new Date(today.getFullYear(), today.getMonth() - 3, 1).toISOString().slice(0, 10).replace(/-/g, '');
    var endDate = today.toISOString().slice(0, 10).replace(/-/g, '');
    authFetch(API + '/tax-invoice/list?startDate=' + startDate + '&endDate=' + endDate).then(function (r) { return r.json(); }).then(function (d) {
      setList(d.success ? (d.invoices || []) : []);
      setListLoading(false);
    }).catch(function () { setListLoading(false); });
  };

  useEffect(function () { if (tab === 'list') loadList(); if (tab === 'received') loadReceived(); }, [tab]);

  var loadReceived = function () {
    setReceivedLoading(true);
    var today = new Date();
    var startDate = new Date(today.getFullYear(), today.getMonth() - 3, 1).toISOString().slice(0, 10).replace(/-/g, '');
    var endDate = today.toISOString().slice(0, 10).replace(/-/g, '');
    authFetch(API + '/tax-invoice/received/list?startDate=' + startDate + '&endDate=' + endDate).then(function (r) { return r.json(); }).then(function (d) {
      setReceivedList(d.success ? (d.invoices || []) : []);
      setReceivedLoading(false);
    }).catch(function () { setReceivedLoading(false); });
  };

  var checkCorp = function () {
    var num = rcvBizNo.replace(/-/g, '');
    if (!num || num.length !== 10) { showToast('\uC0AC\uC5C5\uC790\uBC88\uD638 10\uC790\uB9AC\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694', 'err'); return; }
    setCorpChecking(true); setCorpCheckResult(null);
    authFetch(API + '/tax-invoice/check-corp?corpNum=' + num).then(function (r) { return r.json(); }).then(function (d) {
      setCorpChecking(false);
      if (d.success) {
        setCorpCheckResult(d);
        if (d.corpName && !rcvName) setRcvName(d.corpName);
      } else { setCorpCheckResult({ status: d.error || '\uC870\uD68C \uC2E4\uD328' }); }
    }).catch(function () { setCorpChecking(false); setCorpCheckResult({ status: '\uC870\uD68C \uC2E4\uD328' }); });
  };

  // 세액 산식 — **과세만** 10%. 영세(수출)·면세는 0 (TaxInvoiceCarPickModal.js 의 프리필과 동일 식).
  // 영세율 행에 매출세액이 실리면 홈택스 일괄발급 엑셀이 영세 코드('02') + 세액 을 같은 행에 써서
  // 검증 거부되거나, 통과 시 영세율 매출에 매출세액이 잘못 신고된다 (A3-3, 2026-08-27).
  var taxOf = function (supplyCost, tt) {
    return (tt === '\uACFC\uC138') ? Math.round((parseInt(supplyCost) || 0) * 0.1) : 0;
  };

  // 품목 금액 계산
  var updateItem = function (idx, field, val) {
    setItems(function (prev) {
      var next = prev.slice();
      next[idx] = Object.assign({}, next[idx], { [field]: val });
      if (field === 'qty' || field === 'unitCost') {
        var q = parseInt(next[idx].qty) || 0;
        var u = parseInt(next[idx].unitCost) || 0;
        var sc = q * u;
        next[idx].supplyCost = String(sc);
        next[idx].tax = String(taxOf(sc, taxType));
      }
      return next;
    });
  };

  // 과세 유형 전환 — 이미 입력된 품목의 세액도 같이 재계산한다.
  // (안 하면 '과세로 입력 → 영세로 변경' 이 세액을 남긴 채 발급자료로 넘어간다.)
  var changeTaxType = function (tt) {
    setTaxType(tt);
    setItems(function (prev) {
      return prev.map(function (it) { return Object.assign({}, it, { tax: String(taxOf(it.supplyCost, tt)) }); });
    });
  };

  var addItem = function () {
    setItems(function (prev) { return prev.concat({ date: new Date().toISOString().slice(0, 10).replace(/-/g, ''), itemName: '', spec: '', qty: '1', unitCost: '', supplyCost: '', tax: '', note: '' }); });
  };

  var removeItem = function (idx) {
    setItems(function (prev) { return prev.filter(function (_, i) { return i !== idx; }); });
  };

  // 합계
  var totalSupply = items.reduce(function (s, it) { return s + (parseInt(it.supplyCost) || 0); }, 0);
  var totalTax = items.reduce(function (s, it) { return s + (parseInt(it.tax) || 0); }, 0);
  var totalAmount = totalSupply + totalTax;

  // 발행
  var handleIssue = function () {
    // 영세/면세인데 세액이 남아 있으면(레거시 자료 수정 진입 등) 그대로 내보내지 않는다 (A3-3).
    if (taxType !== '\uACFC\uC138' && totalTax > 0) { showToast('\uBD80\uAC00\uC138\uB294 \uACFC\uC138 \uC720\uD615\uC5D0\uC11C\uB9CC \uC785\uB825\uB429\uB2C8\uB2E4 \u2014 \uACFC\uC138\uB85C \uC804\uD658 \uD6C4 \uB2E4\uC2DC \uC601\uC138\uC728/\uBA74\uC138\uB97C \uC120\uD0DD\uD558\uBA74 \uC138\uC561\uC774 0\uC73C\uB85C \uC7AC\uACC4\uC0B0\uB429\uB2C8\uB2E4', 'err'); return; }
    if (!supBizNo) { showToast('\uACF5\uAE09\uC790 \uC0AC\uC5C5\uC790\uBC88\uD638\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4. \uC5C5\uCCB4 \uC124\uC815\uC744 \uD655\uC778\uD574\uC8FC\uC138\uC694.', 'err'); return; }
    if (!rcvBizNo) { showToast('\uACF5\uAE09\uBC1B\uB294\uC790 \uC0AC\uC5C5\uC790\uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.', 'err'); return; }
    if (items.length === 0 || !items[0].itemName) { showToast('\uD488\uBAA9\uC744 1\uAC1C \uC774\uC0C1 \uC785\uB825\uD574\uC8FC\uC138\uC694.', 'err'); return; }

    setIssuing(true);
    var bizNoClean = (supBizNo || '').replace(/-/g, '');
    var body = {
      writeDate: new Date().toISOString().slice(0, 10).replace(/-/g, ''),
      purposeType: purposeType,
      taxType: taxType,
      supplyCostTotal: totalSupply,
      taxTotal: totalTax,
      totalAmount: totalAmount,
      invoicerCorpNum: bizNoClean,
      invoicerCorpName: supName,
      invoicerCEOName: supCeo,
      invoicerAddr: supAddr,
      invoiceeCorpNum: rcvBizNo.replace(/-/g, ''),
      invoiceeCorpName: rcvName,
      invoiceeCEOName: rcvCeo,
      invoiceeAddr: rcvAddr,
      invoiceeType: '\uC0AC\uC5C5\uC790',
      dtlList: items.map(function (it, i) {
        return { serialNum: i + 1, itemName: it.itemName, unitCost: parseInt(it.unitCost) || 0, qty: parseInt(it.qty) || 1, supplyCost: parseInt(it.supplyCost) || 0, tax: parseInt(it.tax) || 0 };
      })
    };

    authFetch(API + '/tax-invoice/issue', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (d) {
      setIssuing(false);
      if (d.success) {
        showToast('\u2705 \uC138\uAE08\uACC4\uC0B0\uC11C \uBC1C\uD589 \uC644\uB8CC');
        setRcvBizNo(''); setRcvName(''); setRcvCeo(''); setRcvAddr(''); setRcvBizType(''); setRcvBizItem(''); setRcvEmail('');
        setItems([{ date: new Date().toISOString().slice(0, 10).replace(/-/g, ''), itemName: '', spec: '', qty: '1', unitCost: '', supplyCost: '', tax: '', note: '' }]);
      } else {
        showToast(d.error || '\uBC1C\uD589 \uC2E4\uD328', 'err');
      }
    }).catch(function (e) { setIssuing(false); showToast('\uBC1C\uD589 \uC2E4\uD328: ' + (e.message || ''), 'err'); });
  };

  // ── 발행 목록 (홈택스 일괄발급 임시방안) ──
  var resetDraftForm = function () {
    setRcvBizNo(''); setRcvName(''); setRcvCeo(''); setRcvAddr(''); setRcvBizType(''); setRcvBizItem(''); setRcvEmail('');
    setItems([{ date: new Date().toISOString().slice(0, 10).replace(/-/g, ''), itemName: '', spec: '', qty: '1', unitCost: '', supplyCost: '', tax: '', note: '' }]);
    setEditingDraftId(null);
    setSourceType('manual'); setSourceCarIds([]);
  };

  // 판매 차량 불러오기 확정 — 4대까지 폼 프리필 / 5대 이상은 4대 단위 분할 저장
  var handleCarPick = function (picked) {
    setCarPickOpen(false);
    if (picked.length > 4) {
      setSavingDraft(true);
      saveCarSaleDrafts(picked, { taxType: taxType, purposeType: purposeType }).then(function (n) {
        setSavingDraft(false);
        showToast('\u2705 ' + n + '\uAC74\uC73C\uB85C \uBD84\uD560 \uC800\uC7A5');
        resetDraftForm();
        setTab('drafts');
      }).catch(function (e) { setSavingDraft(false); showToast(e.message || '\uC800\uC7A5 \uC2E4\uD328', 'err'); });
      return;
    }
    var buyer = (picked[0] && picked[0].buyer) || {};
    setRcvBizNo(String(buyer.bizNo || '')); setRcvName(buyer.name || ''); setRcvCeo(buyer.ceo || '');
    setRcvAddr(buyer.addr || ''); setRcvEmail(buyer.email || '');
    setItems(buildCarItems(picked, taxType));
    setSourceType('car_sale');
    setSourceCarIds(picked.map(function (c) { return c.carId; }));
    if (!buyer.bizNo) showToast('\uBC14\uC774\uC5B4 \uC0AC\uC5C5\uC790\uBC88\uD638\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4. \uACF5\uAE09\uBC1B\uB294\uC790 \uC0AC\uC5C5\uC790\uBC88\uD638\uB97C \uC9C1\uC811 \uC785\uB825\uD574\uC8FC\uC138\uC694.', 'err');
  };

  // 말소 정산 불러오기 확정 — 모달이 거래처별 draft 를 직접 저장하므로 목록 탭으로 이동
  var handleSettlementSaved = function (n) {
    setSettlementPickOpen(false);
    showToast('\u2705 ' + n + '\uAC74 \uC800\uC7A5 \uC644\uB8CC');
    resetDraftForm();
    setTab('drafts');
  };

  var handleSaveDraft = function () {
    if (taxType === '\uBA74\uC138') { showToast('\uD648\uD0DD\uC2A4 \uC77C\uAD04\uBC1C\uAE09 \uC591\uC2DD\uC740 \uACFC\uC138/\uC601\uC138\uB9CC \uC9C0\uC6D0\uD569\uB2C8\uB2E4', 'err'); return; }
    // 영세/면세인데 세액이 남아 있으면(레거시 자료 수정 진입 등) 그대로 내보내지 않는다 (A3-3).
    if (taxType !== '\uACFC\uC138' && totalTax > 0) { showToast('\uBD80\uAC00\uC138\uB294 \uACFC\uC138 \uC720\uD615\uC5D0\uC11C\uB9CC \uC785\uB825\uB429\uB2C8\uB2E4 \u2014 \uACFC\uC138\uB85C \uC804\uD658 \uD6C4 \uB2E4\uC2DC \uC601\uC138\uC728/\uBA74\uC138\uB97C \uC120\uD0DD\uD558\uBA74 \uC138\uC561\uC774 0\uC73C\uB85C \uC7AC\uACC4\uC0B0\uB429\uB2C8\uB2E4', 'err'); return; }
    if (!rcvBizNo || rcvBizNo.replace(/-/g, '').length !== 10) { showToast('\uACF5\uAE09\uBC1B\uB294\uC790 \uC0AC\uC5C5\uC790\uBC88\uD638 10\uC790\uB9AC\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694', 'err'); return; }
    if (!rcvName) { showToast('\uACF5\uAE09\uBC1B\uB294\uC790 \uC0C1\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694', 'err'); return; }
    if (items.length === 0 || !items[0].itemName) { showToast('\uD488\uBAA9\uC744 1\uAC1C \uC774\uC0C1 \uC785\uB825\uD574\uC8FC\uC138\uC694', 'err'); return; }
    if (items.length > 4) { showToast('\uD648\uD0DD\uC2A4 \uC591\uC2DD\uC740 \uD488\uBAA9 \uCD5C\uB300 4\uAC1C\uAE4C\uC9C0\uC785\uB2C8\uB2E4', 'err'); return; }
    var writeDate = /^\d{8}$/.test(items[0].date || '') ? items[0].date : new Date().toISOString().slice(0, 10).replace(/-/g, '');
    var body = {
      writeDate: writeDate, taxType: taxType, purposeType: purposeType,
      invoiceeCorpNum: rcvBizNo.replace(/-/g, ''), invoiceeCorpName: rcvName, invoiceeCeoName: rcvCeo,
      invoiceeAddr: rcvAddr, invoiceeEmail: rcvEmail,
      supplyCostTotal: totalSupply, taxTotal: totalTax,
      sourceType: sourceType, sourceCarIds: sourceCarIds,
      items: items.map(function (it) { return { name: it.itemName, spec: it.spec || '', qty: parseInt(it.qty) || 1, unitCost: parseInt(it.unitCost) || 0, supplyCost: parseInt(it.supplyCost) || 0, tax: parseInt(it.tax) || 0 }; })
    };
    setSavingDraft(true);
    var url = editingDraftId ? API + '/tax-invoice-drafts/' + editingDraftId : API + '/tax-invoice-drafts';
    authFetch(url, {
      method: editingDraftId ? 'PUT' : 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (d) {
      setSavingDraft(false);
      if (d.success) {
        showToast(editingDraftId ? '\u2705 \uBC1C\uAE09 \uC790\uB8CC\uB97C \uC218\uC815\uD588\uC2B5\uB2C8\uB2E4' : '\u2705 \uBC1C\uAE09 \uC790\uB8CC\uC5D0 \uCD94\uAC00\uD588\uC2B5\uB2C8\uB2E4');
        resetDraftForm();
        setTab('drafts');
      } else { showToast(d.error || '\uC800\uC7A5 \uC2E4\uD328', 'err'); }
    }).catch(function (e) { setSavingDraft(false); showToast('\uC800\uC7A5 \uC2E4\uD328: ' + (e.message || ''), 'err'); });
  };

  // 발행 목록 행 '수정' → 발행 탭 프리필 (저장 시 PUT)
  var startEditDraft = function (d) {
    setRcvBizNo(d.invoiceeCorpNum || ''); setRcvName(d.invoiceeCorpName || ''); setRcvCeo(d.invoiceeCeoName || '');
    setRcvAddr(d.invoiceeAddr || ''); setRcvEmail(d.invoiceeEmail || '');
    setPurposeType(d.purposeType || '\uC601\uC218'); setTaxType(d.taxType || '\uACFC\uC138');
    setItems((d.items && d.items.length ? d.items : [{}]).map(function (it) {
      return { date: d.writeDate || '', itemName: it.name || '', spec: it.spec || '', qty: String(it.qty == null ? 1 : it.qty), unitCost: String(it.unitCost || 0), supplyCost: String(it.supplyCost || 0), tax: String(it.tax || 0), note: '' };
    }));
    // 소스 정보는 수정 저장(PUT)에도 그대로 보존
    var ids = d.sourceCarIds;
    if (typeof ids === 'string' && ids) { try { ids = JSON.parse(ids); } catch (e) { ids = []; } }
    setSourceType(d.sourceType || 'manual');
    setSourceCarIds(Array.isArray(ids) ? ids : []);
    setEditingDraftId(d.id);
    setTab('issue');
  };

  // PDF
  var openPdf = function (itemKey) {
    authFetch(API + '/tax-invoice/' + itemKey + '/pdf').then(function (r) { return r.json(); }).then(function (d) {
      if (d.success && d.url) window.open(d.url, '_blank');
      else showToast('PDF URL \uC870\uD68C \uC2E4\uD328', 'err');
    }).catch(function () { showToast('PDF \uC624\uB958', 'err'); });
  };

  var ls = { display: 'block', fontSize: caMob ? 12 : 11, fontWeight: 600, color: '#64748b', marginBottom: 4, marginTop: 10 };
  // 입력칸 — 대행사 모바일만 터치 타깃 40px (실측 31px 은 손가락으로 못 짚는다). 타 계정은 값 그대로.
  var is = { width: '100%', padding: caMob ? '10px 12px' : '7px 10px', border: '1px solid #d0d5dd', borderRadius: 6, fontSize: caMob ? 13 : 12, outline: 'none', background: '#fff' };
  if (caMob) is.minHeight = 40;
  // 품목 표 안 입력칸 (가로 스크롤 래퍼 안 — 폭은 유지하고 높이만 키운다)
  var itIn = function (w) {
    var s = { width: w, padding: caMob ? '7px 8px' : '4px 6px', border: '1px solid #d0d5dd', borderRadius: 4, fontSize: caMob ? 12.5 : 11 };
    if (caMob) s.minHeight = 34;
    return s;
  };
  // 대행사 모바일에서만 가로 스크롤 래퍼를 씌운다 — 타 계정엔 래퍼 노드가 생기지 않는다.
  var hWrap = function (node) {
    if (!caMob) return node;
    return <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch', maxWidth: '100%' }}>{node}</div>;
  };

  // 탭 UI — 헤더 슬롯으로 포털. 슬롯을 아직 못 찾은 초기 렌더에선 본문 상단에 그린다.
  // 탭 UI — 말소대행 정산 헤더 세그먼트와 같은 모양 (Jin 지시): 테두리 하나로 묶고
  //   활성 칸만 파랑 채움. 헤더 슬롯으로 포털하며, 슬롯을 못 찾은 초기 렌더는 본문 상단.
  var TAX_TABS = [
    { k: 'issue', label: '\uBC1C\uD589' },
    { k: 'drafts', label: '\uD648\uD0DD\uC2A4 \uBC1C\uAE09\uC790\uB8CC' }
  ];
  // 매출/매입은 팝빌 조회 — 백엔드 denyNonAdmin 이라 admin 에게만 노출 (403 빈화면 방지).
  if (isAdmin) {
    TAX_TABS.push({ k: 'list', label: '\uB9E4\uCD9C' });
    TAX_TABS.push({ k: 'received', label: '\uB9E4\uC785' });
  }
  // 사용 안내 — public/guides/tax-invoice-howto.html (이미지 내장 정적 페이지) 를 **새 탭**으로 연다.
  // iframe 임베드는 불가: 응답 헤더가 `X-Frame-Options: DENY` + CSP `frame-src` 에 'self' 부재라
  // 같은 출처인데도 ERR_BLOCKED_BY_CSP 로 막힌다(2026-08 실측 — 종전 iframe 탭은 빈 화면이었다).
  // CSP 는 nginx/LB add_header 라 라우트에서 못 낮춘다(중복 헤더는 더 엄격한 쪽이 이김).
  TAX_TABS.push({ k: 'guide', label: '\uC0AC\uC6A9 \uBC29\uBC95 \u2197',
    href: '/guides/tax-invoice-howto.html?role=' + (isCancelAgency ? 'agency' : 'company') });
  // 말소대행 계정 — 헤더 슬롯의 다른 탭(대행요청·거래처·정산)이 전부 밑줄 탭이라 여기도 같은 문법으로 통일한다
  // (Jin 8/26 시안 1 확정). ⚠ 이 분기 밖(수출업체·관세사·관리자 등)은 종전 pill 그대로 — 한 픽셀도 안 바뀐다.
  var tabsUi = isCancelAgency ? (
    <CaHeaderTabs key="tax-tabs" isMobile={isMobile} items={TAX_TABS.map(function (t) {
      if (t.href) return { label: t.label, href: t.href };
      return { label: t.label, on: tab === t.k, onClick: function () { setTab(t.k); } };
    })}/>
  ) : (
    <span key="tax-tabs" style={{ display: 'inline-flex', border: '1px solid #e2e8f0', borderRadius: 9, overflow: 'hidden', flexShrink: 0 }}>
      {TAX_TABS.map(function (t, i) {
        var on = tab === t.k;
        var cell = { fontSize: 12, fontFamily: 'inherit', cursor: 'pointer', border: 'none',
          borderRight: i < TAX_TABS.length - 1 ? '1px solid #e2e8f0' : 'none',
          background: on ? '#2563EB' : '#fff', color: on ? '#fff' : '#64748b',
          fontWeight: on ? 700 : 600, padding: '5px 13px', whiteSpace: 'nowrap' };
        // href 항목(사용 방법)은 탭 전환이 아니라 새 탭 링크 — 모양은 형제 탭과 동일하게 유지.
        if (t.href) return (
          <a key={t.k} href={t.href} target="_blank" rel="noopener noreferrer"
            style={Object.assign({ textDecoration: 'none', display: 'inline-block', lineHeight: '18px' }, cell)}>{t.label}</a>
        );
        return (
          <button key={t.k} onClick={function () { setTab(t.k); }} style={cell}>{t.label}</button>
        );
      })}
    </span>
  );

  return (
    /* 대행사 모바일 — 고정 높이 + 안쪽 overflowY 는 페이지 안에 또 하나의 스크롤을 만든다
       (그 컨테이너는 overflow-x 도 auto 가 되어 넘친 폭을 조용히 감춘다 — 390 실측 sw=388/cw=366).
       셸의 .dash-content 스크롤 하나만 남기고 자연 높이로 흐르게 한다. */
    <div style={caMob ? { display: 'block' } : { display: 'flex', gap: 16, height: 'calc(100vh - 120px)' }}>
      {showCompanyFilter && <CompanyListPanel user={user} context="tax" month="" selectedCompanyId={filterCompanyId} onSelect={function (id) { setFilterCompanyId(id); }} />}

      <div style={caMob ? { minWidth: 0 } : { flex: 1, overflowY: 'auto' }}>
        {hdrSlotL ? ReactDOM.createPortal(tabsUi, hdrSlotL)
                  : <div style={{ marginBottom: 16 }}>{tabsUi}</div>}

        {tab === 'issue' && (
          /* minmax(0,1fr) — grid item 의 기본 min-width:auto 때문에 품목 표(minWidth 620)가 카드를
             통째로 부풀려 페이지가 가로로 밀렸다(실측 .dash-content sw=666). 0 을 하한으로 못박아
             넘치는 폭은 표 자신의 스크롤 래퍼가 삼키게 한다. */
          <div style={{ display: 'grid', gridTemplateColumns: caMob ? 'minmax(0, 1fr)' : '1fr 1fr', gap: caMob ? 12 : 16 }}>
            {/* 이 탭의 입력이 어디로 가는지 — '발급 자료에 추가'는 즉시 발급이 아님을 명시 (Jin 지시) */}
            <div style={{ gridColumn: '1 / -1', fontSize: 12, color: '#0c4a6e', background: '#f0f9ff', border: '1px solid #bae6fd', borderRadius: 8, padding: '10px 12px', lineHeight: 1.6 }}>
              <strong>{'\u2139\uFE0F \uC5EC\uAE30\uC11C \uC785\uB825\uD55C \uB0B4\uC6A9\uC740 \uBC14\uB85C \uBC1C\uAE09\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.'}</strong>
              {' '}{'\uC544\uB798 "\uBC1C\uAE09 \uC790\uB8CC\uC5D0 \uCD94\uAC00"\uB97C \uB204\uB974\uBA74 \uD648\uD0DD\uC2A4 \uBC1C\uAE09\uC790\uB8CC \uD0ED\uC5D0 \uC313\uC785\uB2C8\uB2E4. \uADF8 \uD0ED\uC5D0\uC11C \uC5D1\uC140\uC744 \uBC1B\uC544 \uD648\uD0DD\uC2A4\uC5D0 \uC5C5\uB85C\uB4DC\uD558\uBA74 \uBC1C\uAE09\uB429\uB2C8\uB2E4.'}
              {isAdmin && <span>{' \uBC18\uBA74 "\uC138\uAE08\uACC4\uC0B0\uC11C \uBC1C\uD589 (\uD31D\uBE4C)"\uC740 \uB204\uB974\uB294 \uC989\uC2DC \uBC1C\uAE09\uB429\uB2C8\uB2E4.'}</span>}
            </div>
            {/* 공급자 */}
            <div className="card" style={{ padding: 16 }}>
              <h3 style={{ fontSize: 14, marginBottom: 12, color: '#1B3A5C' }}>{'\uACF5\uAE09\uC790 \uC815\uBCF4'}</h3>
              {/* 대행사는 업체 정보가 없다 — 정산 불러오기 시 대행사 스냅샷이 공급자로 저장됨 */}
              {isCancelAgency && <div style={{ fontSize: 11, color: '#7c3aed', background: '#f5f3ff', borderRadius: 6, padding: '7px 10px', marginBottom: 8, lineHeight: 1.5 }}>{'\uB300\uD589\uC0AC \uC0AC\uC5C5\uC790 \uC815\uBCF4\uB97C \uBD88\uB7EC\uC654\uC2B5\uB2C8\uB2E4. \uC774\uB300\uB85C \uBC1C\uAE09\uB418\uBA70, \uC774\uBC88 \uAC74\uB9CC \uACE0\uCCD0 \uC4F8 \uC218\uB3C4 \uC788\uC2B5\uB2C8\uB2E4.'}</div>}
              <label style={ls}>{'\uC0AC\uC5C5\uC790\uBC88\uD638'}</label>
              <input style={Object.assign({}, is, { background: '#f8fafc' })} value={supBizNo} onChange={function(e){setSupBizNo(e.target.value)}} />
              <label style={ls}>{'\uC0C1\uD638'}</label>
              <input style={Object.assign({}, is, { background: '#f8fafc' })} value={supName} onChange={function(e){setSupName(e.target.value)}} />
              <label style={ls}>{'\uB300\uD45C\uC790'}</label>
              <input style={Object.assign({}, is, { background: '#f8fafc' })} value={supCeo} onChange={function(e){setSupCeo(e.target.value)}} />
              <label style={ls}>{'\uC8FC\uC18C'}</label>
              <input style={Object.assign({}, is, { background: '#f8fafc' })} value={supAddr} onChange={function(e){setSupAddr(e.target.value)}} />
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                <div><label style={ls}>{'\uC5C5\uD0DC'}</label><input style={Object.assign({}, is, { background: '#f8fafc' })} value={supBizType} onChange={function(e){setSupBizType(e.target.value)}} /></div>
                <div><label style={ls}>{'\uC885\uBAA9'}</label><input style={Object.assign({}, is, { background: '#f8fafc' })} value={supBizItem} onChange={function(e){setSupBizItem(e.target.value)}} /></div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                <div><label style={ls}>{'\uC804\uD654\uBC88\uD638'}</label><input style={Object.assign({}, is, { background: '#f8fafc' })} value={supTel} onChange={function(e){setSupTel(e.target.value)}} /></div>
                <div><label style={ls}>{'\uC774\uBA54\uC77C'}</label><input style={Object.assign({}, is, { background: '#f8fafc' })} value={supEmail} onChange={function(e){setSupEmail(e.target.value)}} /></div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginTop: 10 }}>
                <div>
                  <label style={ls}>{'\uBC1C\uD589 \uC720\uD615'}</label>
                  <select style={is} value={purposeType} onChange={function (e) { setPurposeType(e.target.value); }}>
                    <option value={'\uC601\uC218'}>{'\uC601\uC218'}</option>
                    <option value={'\uCCAD\uAD6C'}>{'\uCCAD\uAD6C'}</option>
                  </select>
                </div>
                <div>
                  <label style={ls}>{'\uACFC\uC138 \uC720\uD615'}</label>
                  <select style={is} value={taxType} onChange={function (e) { changeTaxType(e.target.value); }}>
                    <option value={'\uACFC\uC138'}>{'\uACFC\uC138'}</option>
                    <option value={'\uC601\uC138'}>{'\uC601\uC138'}</option>
                    <option value={'\uBA74\uC138'}>{'\uBA74\uC138'}</option>
                  </select>
                </div>
              </div>
            </div>

            {/* 공급받는자 */}
            <div className="card" style={{ padding: 16 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, flexWrap: caMob ? 'wrap' : undefined, gap: caMob ? 8 : undefined }}>
                <h3 style={{ fontSize: 14, margin: 0, color: '#1B3A5C' }}>{'\uACF5\uAE09\uBC1B\uB294\uC790 \uC815\uBCF4'}</h3>
                {/* 대행사는 매각 차량이 아니라 말소 정산이 발행 소스 */}
                {isCancelAgency ? (
                  <button onClick={function () { setSettlementPickOpen(true); }} style={caMob
                    ? { flex: '1 1 100%', minHeight: 42, padding: '0 14px', borderRadius: 8, border: '1px solid #7c3aed', background: '#f5f3ff', color: '#7c3aed', fontSize: 13, fontWeight: 700, cursor: 'pointer' }
                    : { padding: '5px 14px', borderRadius: 6, border: '1px solid #7c3aed', background: '#f5f3ff', color: '#7c3aed', fontSize: 11, fontWeight: 700, cursor: 'pointer' }}>{'\uB9D0\uC18C \uC815\uC0B0 \uBD88\uB7EC\uC624\uAE30'}</button>
                ) : (
                  <button onClick={function () { setCarPickOpen(true); }} style={{ padding: '5px 14px', borderRadius: 6, border: '1px solid #0891b2', background: '#ecfeff', color: '#0891b2', fontSize: 11, fontWeight: 700, cursor: 'pointer' }}>{'\uAD6D\uB0B4 \uB9E4\uAC01 \uCC28\uB7C9 \uBD88\uB7EC\uC624\uAE30'}</button>
                )}
              </div>
              {sourceType === 'car_sale' && sourceCarIds.length > 0 && <div style={{ fontSize: 11, color: '#0891b2', fontWeight: 700, marginBottom: 6 }}>{'\uB9E4\uAC01 \uCC28\uB7C9 ' + sourceCarIds.length + '\uB300 \uC5F0\uACB0\uB428'}</div>}
              <label style={ls}>{'\uC0AC\uC5C5\uC790\uBC88\uD638'}</label>
              <div style={{ display: 'flex', gap: 6 }}>
                <input style={Object.assign({}, is, { flex: 1 })} value={rcvBizNo} onChange={function (e) { setRcvBizNo(e.target.value); setCorpCheckResult(null); }} placeholder="000-00-00000" />
                <button onClick={checkCorp} disabled={corpChecking} style={{ padding: caMob ? '0 16px' : '6px 12px', minHeight: caMob ? 40 : undefined, borderRadius: 6, border: '1px solid #d0d5dd', background: corpChecking ? '#f1f5f9' : '#fff', fontSize: caMob ? 13 : 11, fontWeight: 700, cursor: corpChecking ? 'default' : 'pointer', whiteSpace: 'nowrap' }}>{corpChecking ? '...' : '\uC870\uD68C'}</button>
              </div>
              {corpCheckResult && <div style={{ marginTop: 4, fontSize: 11, fontWeight: 700, color: corpCheckResult.status === '\uC815\uC0C1' ? '#16a34a' : corpCheckResult.status === '\uD734\uC5C5' ? '#d97706' : corpCheckResult.status === '\uD3D0\uC5C5' ? '#dc2626' : '#94a3b8' }}>
                {corpCheckResult.status}{corpCheckResult.corpName ? ' \u2014 ' + corpCheckResult.corpName : ''}
              </div>}
              <label style={ls}>{'\uC0C1\uD638'}</label>
              <input style={is} value={rcvName} onChange={function (e) { setRcvName(e.target.value); }} />
              <label style={ls}>{'\uB300\uD45C\uC790'}</label>
              <input style={is} value={rcvCeo} onChange={function (e) { setRcvCeo(e.target.value); }} />
              <label style={ls}>{'\uC8FC\uC18C'}</label>
              <input style={is} value={rcvAddr} onChange={function (e) { setRcvAddr(e.target.value); }} />
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                <div><label style={ls}>{'\uC5C5\uD0DC'}</label><input style={is} value={rcvBizType} onChange={function (e) { setRcvBizType(e.target.value); }} /></div>
                <div><label style={ls}>{'\uC885\uBAA9'}</label><input style={is} value={rcvBizItem} onChange={function (e) { setRcvBizItem(e.target.value); }} /></div>
              </div>
              <label style={ls}>{'\uC774\uBA54\uC77C'}</label>
              <input style={is} value={rcvEmail} onChange={function (e) { setRcvEmail(e.target.value); }} placeholder="email@example.com" type="email" />
            </div>

            {/* 품목 */}
            <div className="card" style={{ padding: 16, gridColumn: '1 / -1' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                <h3 style={{ fontSize: 14, margin: 0, color: '#1B3A5C' }}>{'\uD488\uBAA9 (' + items.length + '\uAC74)'}</h3>
                <button onClick={addItem} style={{ padding: caMob ? '0 14px' : '4px 12px', minHeight: caMob ? 38 : undefined, borderRadius: 6, border: '1px solid #2563eb', background: '#eff6ff', color: '#2563eb', fontSize: caMob ? 12.5 : 11, fontWeight: 700, cursor: 'pointer' }}>+ {'\uD488\uBAA9 \uCD94\uAC00'}</button>
              </div>
              {/* 8열 표는 390 에서 '품목명'·'공급가액' 이 세로로 쪼개질 만큼 눌린다 → 표만 가로 스크롤
                  (페이지 가로 스크롤 금지 원칙 — 래퍼 안에서만 민다). 대행사 모바일에서만 래퍼가 생기고
                  나머지 계정은 래퍼 노드조차 붙지 않는다 (DOM 무변경). */}
              {caMob && <div style={{ fontSize: 11.5, color: '#94a3b8', marginBottom: 6 }}>{'\uD45C\uB97C \uC88C\uC6B0\uB85C \uBC00\uBA74 \uB2E8\uAC00\u00B7\uACF5\uAE09\uAC00\uC561\u00B7\uC138\uC561\uC774 \uB098\uC635\uB2C8\uB2E4 \u2192'}</div>}
              {hWrap(
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12, minWidth: caMob ? 620 : undefined }}>
                <thead>
                  <tr style={{ background: '#f8fafc' }}>
                    {['\uC77C\uC790', '\uD488\uBAA9\uBA85', '\uADDC\uACA9', '\uC218\uB7C9', '\uB2E8\uAC00', '\uACF5\uAE09\uAC00\uC561', '\uC138\uC561', ''].map(function (h, i) {
                      return <th key={i} style={{ padding: '8px 6px', borderBottom: '2px solid #e2e8f0', textAlign: 'left', fontWeight: 700, color: '#475569' }}>{h}</th>;
                    })}
                  </tr>
                </thead>
                <tbody>
                  {items.map(function (it, idx) {
                    return (
                      <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
                        <td style={{ padding: 4 }}><input style={itIn(80)} value={it.date} onChange={function (e) { updateItem(idx, 'date', e.target.value); }} placeholder="YYYYMMDD" /></td>
                        <td style={{ padding: 4 }}><input style={itIn('100%')} value={it.itemName} onChange={function (e) { updateItem(idx, 'itemName', e.target.value); }} /></td>
                        <td style={{ padding: 4 }}><input style={itIn(60)} value={it.spec} onChange={function (e) { updateItem(idx, 'spec', e.target.value); }} /></td>
                        <td style={{ padding: 4 }}><input style={Object.assign({}, itIn(40), { textAlign: 'right' })} type="number" value={it.qty} onChange={function (e) { updateItem(idx, 'qty', e.target.value); }} /></td>
                        <td style={{ padding: 4 }}><input style={Object.assign({}, itIn(80), { textAlign: 'right' })} type="number" value={it.unitCost} onChange={function (e) { updateItem(idx, 'unitCost', e.target.value); }} /></td>
                        <td style={{ padding: 4, textAlign: 'right', fontWeight: 600, fontSize: 11 }}>{(parseInt(it.supplyCost) || 0).toLocaleString()}</td>
                        <td style={{ padding: 4, textAlign: 'right', fontSize: 11 }}>{(parseInt(it.tax) || 0).toLocaleString()}</td>
                        <td style={{ padding: 4 }}>{items.length > 1 && <button onClick={function () { removeItem(idx); }} style={{ background: '#fee2e2', border: 'none', borderRadius: 4, padding: caMob ? '8px 10px' : '2px 8px', cursor: 'pointer', fontSize: caMob ? 12 : 10, color: '#dc2626' }}>{'\uC0AD\uC81C'}</button>}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>)}

              {/* 합계 */}
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16, gap: 20 }}>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontSize: 12, color: '#64748b' }}>{'\uACF5\uAE09\uAC00\uC561'}: <b>{totalSupply.toLocaleString()}</b></div>
                  <div style={{ fontSize: 12, color: '#64748b' }}>{'\uC138\uC561'}: <b>{totalTax.toLocaleString()}</b></div>
                  <div style={{ fontSize: 16, fontWeight: 800, color: '#1B3A5C', marginTop: 4 }}>{'\uD569\uACC4'}: {totalAmount.toLocaleString()}{'\uC6D0'}</div>
                </div>
              </div>

              {/* 발행 버튼 — 목록 저장(전 사용자) / 팝빌 즉시발행(admin, 백엔드 denyNonAdmin) */}
              <div style={{ display: 'flex', gap: 8, marginTop: 16, flexWrap: caMob ? 'wrap' : undefined }}>
                <button onClick={handleSaveDraft} disabled={savingDraft} style={{ flex: caMob ? '1 1 100%' : 1, padding: '14px', background: savingDraft ? '#94a3b8' : '#0891b2', color: '#fff', border: 'none', borderRadius: 10, fontSize: 15, fontWeight: 700, cursor: savingDraft ? 'default' : 'pointer' }}>
                  {savingDraft ? '\uC800\uC7A5 \uC911...' : (editingDraftId ? '\uD83D\uDCBE \uBC1C\uAE09 \uC790\uB8CC \uC218\uC815 \uC800\uC7A5' : '\uD83D\uDCBE \uBC1C\uAE09 \uC790\uB8CC\uC5D0 \uCD94\uAC00 (\uD648\uD0DD\uC2A4)')}
                </button>
                {editingDraftId && <button onClick={resetDraftForm} style={{ flex: caMob ? '1 1 100%' : undefined, padding: '14px 20px', background: '#fff', color: '#475569', border: '1px solid #d0d5dd', borderRadius: 10, fontSize: 14, fontWeight: 700, cursor: 'pointer' }}>{'\uC218\uC815 \uCDE8\uC18C'}</button>}
                {isAdmin && <button onClick={handleIssue} disabled={issuing} style={{ flex: 1, padding: '14px', background: issuing ? '#94a3b8' : '#2563eb', color: '#fff', border: 'none', borderRadius: 10, fontSize: 15, fontWeight: 700, cursor: issuing ? 'default' : 'pointer' }}>
                  {issuing ? '\uBC1C\uD589 \uC911...' : '\uD83D\uDCDD \uC138\uAE08\uACC4\uC0B0\uC11C \uBC1C\uD589 (\uD31D\uBE4C)'}
                </button>}
              </div>
            </div>
          </div>
        )}

        {tab === 'drafts' && <TaxInvoiceDrafts showToast={showToast} onEdit={startEditDraft} user={user} />}

        {carPickOpen && <TaxInvoiceCarPickModal showToast={showToast} onClose={function () { setCarPickOpen(false); }} onConfirm={handleCarPick} />}

        {settlementPickOpen && <TaxInvoiceSettlementPickModal showToast={showToast} onClose={function () { setSettlementPickOpen(false); }} onSaved={handleSettlementSaved} />}

        <TaxInvoicePopbillLists tab={tab} list={list} listLoading={listLoading} loadList={loadList}
          receivedList={receivedList} receivedLoading={receivedLoading} loadReceived={loadReceived}
          openPdf={openPdf} />
      </div>
    </div>
  );
}

export default TaxInvoicePage;
